import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'tableCustomFilter'
})
export class TableCustomFilterPipe implements PipeTransform {
  transform(data: any, toFilter: string): any {
    if (!toFilter) { return data; }
    return data.filter(d => d.value === toFilter);
  }
}